import {Trans} from '@lingui/macro';
import React from 'react';

import {CollapsedItemKeyPrefixesEnum} from '../../models/api/localPreferencesModel';
import {helpCenterUrl} from '../../store/stateless/navigationActions';
import {useSettingsInfoBox, UseSettingsInfoBoxProps} from '../helpers/settingsInfoBox';

/*
 * Consts.
 */

const settingsInfoBoxProps: UseSettingsInfoBoxProps = {
  settingsExpandedKey: CollapsedItemKeyPrefixesEnum.SETTINGS_INBOX_BUSINESS_HOURS,
  title: <Trans id="business-hours-settings-inbox-info-title">Setting business hours</Trans>,
  body: (
    <p>
      <Trans id="business-hours-settings-inbox-info">
        Define business hours for this team inbox to better inform analytics and SLA rules. For example, reply
        time in analytics could refer to how long it takes to answer a message within business hours. By
        defining business hours for the inbox, it is possible to have multiple business hours within a single
        team.
      </Trans>
    </p>
  ),
  link: `${helpCenterUrl}/t/35hz4tx/business-hours`,
};

/*
 * Hook.
 */

export function useInboxBusinessHoursInfoBox() {
  return useSettingsInfoBox(settingsInfoBoxProps);
}
